import React from "react";

const Loading = ({ message = "Loading...", size = "md", type = "spinner" }) => {
    // Define sizes for different spinners
    const sizeClasses = {
        sm: "w-6 h-6 border-2",
        md: "w-10 h-10 border-4",
        lg: "w-16 h-16 border-8",
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen">
            {/* Spinner */}
            {type === "spinner" && (
                <div
                    className={`${sizeClasses[size]} border-t-transparent border-orange-500 border-solid rounded-full animate-spin`}
                ></div>
            )}
            {/* Dot Loader */}
            {type === "dots" && (
                <div className="flex gap-2 mt-2">
                    {[...Array(3)].map((_, i) => (
                        <div
                            key={i}
                            className={`${size === "lg" ? "w-6 h-6" : size === "md" ? "w-4 h-4" : "w-2 h-2"
                                } bg-orange-500 rounded-full animate-pulse`}
                            style={{ animationDelay: `${i * 0.2}s` }}
                        ></div>
                    ))}
                </div>
            )}
            {/* Loading Message */}
            <p className="mt-4 text-sm text-gray-500">{message}</p>
        </div>
    );
};

export default Loading;
